import React from "react";
import { Link, useLocation } from "react-router-dom";
import SafeIcon from "../common/SafeIcon";
import * as FiIcons from "react-icons/fi";
import { version } from "../../package.json";

const {
  FiHome,
  FiShoppingCart,
  FiSettings,
  FiCalendar,
  FiSeed,
  FiActivity,
  FiLogOut,
  FiUser,
  FiPackage,
  FiTruck,
  FiRepeat,
} = FiIcons;

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const menuItems = [
    {
      path: "/",
      icon: FiHome,
      label: "Dashboard",
      description: "Overview & Tasks",
    },
    {
      path: "/sowing",
      icon: FiSeed,
      label: "Operation",
      description: "Production Tasks",
    },
    {
      path: "/delivery",
      icon: FiTruck,
      label: "Delivery",
      description: "Fulfillment",
    },
    {
      path: "/orders",
      icon: FiShoppingCart,
      label: "Orders",
      description: "Order Management",
    },
    {
      path: "/recurring-rules",
      icon: FiRepeat,
      label: "Recurring Orders",
      description: "Automated Orders",
    },
    {
      path: "/customers",
      icon: FiUser,
      label: "Customers",
      description: "Client Settings",
    },
    {
      path: "/varieties",
      icon: FiPackage,
      label: "Varieties",
      description: "Crop Settings",
    },
    {
      path: "/calendar",
      icon: FiCalendar,
      label: "Calendar",
      description: "Production Schedule",
    },
    {
      path: "/history",
      icon: FiActivity,
      label: "History",
      description: "Stock & Buffers",
    },
  ];

  const handleLogout = () => {
    localStorage.removeItem("microgreens-auth");
    window.location.reload();
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-20 md:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar Container */}
      <div
        className={`fixed left-0 top-0 h-full w-64 bg-white shadow-xl z-30 border-r border-gray-100 flex flex-col transition-transform duration-300 transform ${isOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
      >
        <div className="p-8 border-b border-gray-100 flex flex-col items-center relative">
          {/* Mobile Close Button */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-2 text-gray-400 hover:text-red-500 md:hidden"
          >
            <SafeIcon icon={FiIcons.FiX} />
          </button>

          <div className="w-24 h-24 mb-4 rounded-full overflow-hidden shadow-sm border-2 border-green-50">
            <img
              src="/logo.png"
              alt="LetsGreen Logo"
              className="w-full h-full object-cover"
            />
          </div>
          <h1 className="text-2xl font-bold text-[#1e3a8a] tracking-wide">
            LETSGREEN
          </h1>
          <p className="text-[10px] font-medium text-[#16a34a] uppercase tracking-[0.2em] mt-1">
            Grow Quality
          </p>
        </div>

        <nav className="mt-8 px-4 flex-1">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-3 px-4 py-3.5 mb-2 rounded-lg transition-all duration-200 group ${
                  isActive
                    ? "bg-[#1e3a8a] text-white shadow-md shadow-blue-100"
                    : "text-gray-500 hover:bg-gray-50 hover:text-[#1e3a8a]"
                }`}
              >
                <SafeIcon
                  icon={item.icon}
                  className={`text-xl ${isActive ? "text-white" : "text-gray-400 group-hover:text-[#16a34a]"}`}
                />
                <div>
                  <div
                    className={`text-sm tracking-wide ${isActive ? "font-medium" : "font-light"}`}
                  >
                    {item.label}
                  </div>
                </div>
              </Link>
            );
          })}
        </nav>

        <div className="p-4 border-t border-gray-100">
          <button
            onClick={handleLogout}
            className="flex items-center space-x-3 px-4 py-3 w-full text-gray-500 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors"
          >
            <SafeIcon icon={FiLogOut} />
            <span className="font-light text-sm">Sign Out</span>
          </button>
          <div className="mt-2 text-center">
            <span className="text-xs text-gray-300 font-mono">v{version}</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
